import { RouteLink } from "../../../types/route-link"
import { faFolderOpen, faMap, faUsers, faUsersViewfinder, faUserShield, faServer, faPuzzlePiece } from "@fortawesome/free-solid-svg-icons"

const adminRouteLinks: Array<RouteLink> = [
    {
        path: "/roles",
        name: "Roles",
        icon: faUserShield,
    },
    {
        path: "/bi-server",
        name: "BI Server",
        icon: faServer,
    },
    {
        path: "/teams",
        name: "Teams",
        icon: faUsersViewfinder,
    },
    {
        path: "/db-users",
        name: "Users",
        icon: faUsers,
    },
    {
        path: "/widgetinstance-config",
        name: "Widgets",
        icon: faPuzzlePiece,
    },
    {
        path: "/data-management",
        name: "Data Management",
        icon: faMap,
    },
    // {
    //     path: "/document-verification",
    //     name: "Documents",
    //     icon: faFolderOpen,
    // },
    {
        path: "/folder-management",
        name: "Documents",
        icon: faFolderOpen,
    }
    // {
    //     path: "/settings",
    //     name: "Settings",
    //     icon: faCogs,
    // }
]

export default adminRouteLinks